import { Box, Typography, Modal, Container } from "@mui/material";
import "../common/styles/colors.scss";
import "./components.scss";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";

export const AppMessage = (props) => {
  const { t } = useTranslation();
  const { isOpen, message, handleClose } = props;
  return (
    <Modal keepMounted open={isOpen} onClose={handleClose}>
      <Container maxWidth="xl">
        <Box
          sx={{
            position: "absolute",
            top: "40%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            maxWidth: 600,
            minHeight: 200,
            bgcolor: "background.paper",
            borderRadius: "15px",
            boxShadow: 24,
            p: 4,
            textAlign: "center",
            padding: "20px 20px",
            minWidth: 300,
          }}
        >
          <Typography sx={{ textAlign: "right", cursor: "pointer" }}>
            <CloseIcon
              onClick={() => {
                handleClose();
              }}
            />
          </Typography>

          <Typography
            sx={{
              padding: "20px 20px",
            }}
            id="keep-mounted-modal-title"
            variant="h6"
            component="h2"
          >
            {t(message)}
          </Typography>
        </Box>
      </Container>
    </Modal>
  );
};
